import {Box} from '@chakra-ui/react'
import styled from '@emotion/styled'

export const Banner = styled(Box)`
  .banner-image {
    height: 30vh;
    width: 100%;
    object-fit: cover;
  }
`
